import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import './kbarticle.css';
import './kblist.css';
import './login.css';
import './menu.css';
import './navbar.css';
import './sidebar.css';
import './ticket.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
